// Hive3D — global.js

// Gift list store (persists in this browser; shared via URL on the gift picker page)
window.HiveGift = {
  key: 'hive3d_giftlist',
  get: function () {
    try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
  },
  save: function (list) {
    try { localStorage.setItem(this.key, JSON.stringify(list.slice(0, 40))); } catch (e) {}
    this.badge();
  },
  has: function (h, v) {
    return this.get().some(function (x) { return x.h === h && String(x.v) === String(v); });
  },
  add: function (h, v) {
    var l = this.get();
    if (!l.some(function (x) { return x.h === h && String(x.v) === String(v); })) l.push({ h: h, v: v });
    this.save(l);
  },
  remove: function (h, v) {
    this.save(this.get().filter(function (x) { return !(x.h === h && String(x.v) === String(v)); }));
  },
  toggle: function (h, v) {
    if (this.has(h, v)) { this.remove(h, v); return false; }
    this.add(h, v); return true;
  },
  badge: function () {
    var el = document.getElementById('GiftCount');
    if (!el) return;
    var n = this.get().length;
    el.textContent = n;
    el.style.display = n ? 'flex' : 'none';
  }
};

// Live cart count badge (updated after quick-add without a page reload)
window.HiveCart = {
  badge: function (n) {
    var el = document.getElementById('CartCount');
    if (!el) return;
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
    el.classList.remove('bump');
    void el.offsetWidth; // restart the pulse animation
    if (n > 0) el.classList.add('bump');
  }
};

document.addEventListener('DOMContentLoaded', function () {
  // Gift list: header badge + delegated 🎁 toggles
  HiveGift.badge();

  // Quick-add: add to cart in place from product cards
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa || qa.disabled) return;
    e.preventDefault();
    var original = qa.textContent;
    qa.disabled = true;
    qa.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(qa.getAttribute('data-quick-add')), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        HiveCart.badge(cart.item_count);
        qa.textContent = 'Added ✓';
        qa.classList.add('added');
        setTimeout(function () {
          qa.disabled = false;
          qa.classList.remove('added');
          qa.textContent = original;
        }, 2000);
      })
      .catch(function () {
        qa.disabled = false;
        qa.textContent = 'Try again';
        setTimeout(function () { qa.textContent = original; }, 2000);
      });
  });

  // Product form: "Adding…" feedback while the native submit navigates to the cart
  var productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', function () {
      var btn = productForm.querySelector('[data-add-to-cart]');
      if (btn && !btn.disabled) {
        btn.textContent = 'Adding…';
        btn.disabled = true;
      }
    });
  }
  document.querySelectorAll('[data-gift-handle]').forEach(function (b) {
    var v = null;
    if ('giftUseVariant' in b.dataset) {
      var idEl = document.querySelector('.product-form [name="id"]');
      if (idEl) v = idEl.value;
    }
    if (HiveGift.has(b.dataset.giftHandle, v)) {
      b.classList.add('added');
      if (b.classList.contains('gift-add-inline')) b.textContent = '✓ On your gift list';
      else b.textContent = '✓';
    }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gift-handle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var v = null;
    if ('giftUseVariant' in b.dataset) {
      var idEl = document.querySelector('.product-form [name="id"]');
      if (idEl) v = idEl.value;
    }
    var added = HiveGift.toggle(b.dataset.giftHandle, v);
    b.classList.toggle('added', added);
    if (b.classList.contains('gift-add-inline')) {
      b.textContent = added ? '✓ On your gift list' : '🎁 Add to gift list';
    } else {
      b.textContent = added ? '✓' : '🎁';
    }
  });
  // Mobile menu toggle
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }


  // v7: nav dropdowns — click/tap, keyboard, Escape, outside click
  (function () {
    var dds = document.querySelectorAll('[data-nav-dd]');
    if (!dds.length) return;
    function setOpen(dd, open) {
      dd.classList.toggle('is-open', open);
      var b = dd.querySelector('.nav-dd__btn');
      if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) { dds.forEach(function (d) { if (d !== except) setOpen(d, false); }); }
    var hoverable = window.matchMedia('(hover: hover) and (min-width: 821px)');
    dds.forEach(function (dd) {
      var btn = dd.querySelector('.nav-dd__btn');
      var links = function () { return dd.querySelectorAll('.nav-dd__panel a'); };
      btn.addEventListener('click', function () {
        var open = !dd.classList.contains('is-open'); closeAll(dd); setOpen(dd, open);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); closeAll(dd); setOpen(dd, true); var l = links(); if (l[0]) l[0].focus(); }
      });
      dd.addEventListener('mouseenter', function () { if (hoverable.matches) { closeAll(dd); setOpen(dd, true); } });
      dd.addEventListener('mouseleave', function () { if (hoverable.matches) setOpen(dd, false); });
      dd.addEventListener('keydown', function (e) {
        var l = Array.prototype.slice.call(links()); var i = l.indexOf(document.activeElement);
        if (e.key === 'Escape') { setOpen(dd, false); btn.focus(); }
        else if (i > -1 && e.key === 'ArrowDown') { e.preventDefault(); (l[i + 1] || l[0]).focus(); }
        else if (i > -1 && e.key === 'ArrowUp') { e.preventDefault(); (l[i - 1] || btn).focus(); }
      });
      dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) setOpen(dd, false); });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-nav-dd]')) closeAll(); });
  })();

  // Product gallery thumbnail swap
  document.querySelectorAll('.product-page__thumbs img').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('.product-page__gallery .main-image');
      if (main && thumb.dataset.full) {
        main.src = thumb.dataset.full;
        if (thumb.alt) main.alt = thumb.alt;
      }
    });
  });

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  // Scroll-reveal is handled entirely in CSS (scroll-driven animations in base.css)
  // so content can never be stuck hidden by JavaScript.

  // Hero mouse parallax: media tilts gently toward the cursor
  var heroMedia = document.querySelector('.hero__media');
  if (heroMedia && !reduceMotion && !designMode && window.matchMedia('(pointer: fine)').matches) {
    heroMedia.classList.remove('floaty'); // parallax replaces the idle bob
    var hx = 0, hy = 0, thx = 0, thy = 0;
    window.addEventListener('mousemove', function (e) {
      thx = (e.clientX / window.innerWidth - 0.5) * 14;
      thy = (e.clientY / window.innerHeight - 0.5) * 10;
    }, { passive: true });
    (function heroTick() {
      hx += (thx - hx) * 0.06;
      hy += (thy - hy) * 0.06;
      heroMedia.style.transform = 'translate(' + hx.toFixed(2) + 'px,' + hy.toFixed(2) + 'px) rotate(' + (hx * 0.08).toFixed(2) + 'deg)';
      requestAnimationFrame(heroTick);
    })();
  }

  // Variant price update
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    var variants = JSON.parse(document.getElementById('ProductVariants').textContent);
    variantSelect.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === variantSelect.value; });
      if (!v) return;
      if (v.price_formatted) {
        document.querySelectorAll('[data-product-price]').forEach(function (el) {
          el.textContent = v.price_formatted;
        });
      }
      if (v.instalment_formatted) {
        document.querySelectorAll('[data-instalment-amount]').forEach(function (el) {
          el.textContent = v.instalment_formatted;
        });
      }
      var btn = document.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.textAdd : btn.dataset.textSoldout;
      }
      var stickyBtn = document.querySelector('[data-sticky-atc]');
      if (stickyBtn) stickyBtn.disabled = !v.available;
    });
  }
});
